import PlanCuentasModal from "./PlanCuentasModal";
export default PlanCuentasModal;